var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thread-list"},[_c('h2',{staticClass:"list-title"},[_vm._v("Threads")]),_vm._v(" "),_vm._l((_vm.threads),function(thread){return _c('ThreadListItem',{key:thread['.key'],attrs:{"thread":thread}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e4f6c09","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThreadList.vue
// module id = +5a1
// module chunks = 1